import { inject, observer } from "mobx-react";

import {
  Button, Card
  //@ts-ignore
} from '@microui/react-ui';
import CreateAccount from "./CreateAccount";
import InviteMember from "./InviteMember";

const AddMember = ({ store }: any) => {
  return (
    <Card
      head={
        <div className="flex w-full gap-3">
          <Button
            block
            type="primary"
            color={store.typeAccount == 'invite' ? 'primary' : 'white'}
            onClick={() => {
              store.typeAccount = 'invite';
              store.selectedAccount = null;
            }}
          >
            Thêm thành viên từ danh sách
          </Button>
          <Button
            block
            type="primary"
            color={store.typeAccount == 'create' ? 'primary' : 'white'}
            onClick={() => {
              store.typeAccount = 'create';
              store.selectedAccount = null;
            }}
          >
            Tạo thành viên mới
          </Button>
        </div>
      }
      className="max-w-[900px] flex flex-col"
      bodyClassName="flex-1 overflow-auto"
    >
      {store.typeAccount == 'invite' && (
        <InviteMember />
      )}
      {store.typeAccount == 'create' && (
        <CreateAccount />
      )}
    </Card>
  );
};

export default inject('store')(observer(AddMember));